import React from 'react';
import Icon from '@sabre/spark-react-core/icon';
import { func, bool } from 'prop-types';

const Favourite = ({ value, setValue }) => {
   const handleFavouriteIconClick = () => {
      setValue(!value);
   };
   return (
      <div className='small-icon'>
      <Icon
         name='star'
         data-testid='favourite-star-test-id'
         size='md'
         style={value ? 'fill' : 'line'}
         label='Fav'
         className={`spark-flex fav-pointer spark-text-center fav-center ${
            value ? 'fav-selected' : ''
         }`}
         onClick={handleFavouriteIconClick}
      />
      </div>
   );
};
Favourite.propTypes = {
   value: bool,
   setValue: func,
};

export default Favourite;
